import ComfilterPicker from './comfilter-picker';

const $filter = (() => {
	let instance = null

	function getInstance(context) {
		if (!!instance) {
			instance.$el.parentElement.removeChild(instance.$el)
			instance.$destroy()
		}
		instance = new Vue({
			...LinkUtils.deepCopy(ComfilterPicker),
			parent: context,
		}).$mount()
		window.document.body.appendChild(instance.$el)

		return instance
	}

	return {
		pick({filterOptions, filterResults, onConfirm, interfacePath, onSave, context}) {
			const instance = getInstance(context)
			instance.openPicker({
				filterOptions: LinkUtils.deepCopy(filterOptions),
				filterResults: LinkUtils.deepCopy(filterResults) || [],
				onConfirm,
				interfacePath,
				onSave
			});
		},
		/**
		 * 获取filters
		 * @author  韦胜健
		 * @date    2019/3/29 10:58
		 */
		async getFilters(filterOptions) {
			const instance = getInstance()
			await Vue.prototype.$lv.nextTick()
			await instance.filter.initOptions(filterOptions)
			return instance.filter.filters
		},
	}
})();

export default $filter
